export default __webpack_public_path__ + "static/media/playlists.f2780476.svg";